import { Component, Prop, Vue } from 'vue-property-decorator'

import emailsHelper from '@/helpers/emails'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import BadgeAprovado from '@/components/edit/BadgeAprovado/index.vue'
import BadgeNaoAprovado from '@/components/edit/BadgeNaoAprovado/index.vue'
import BadgePendente from '@/components/edit/BadgePendente/index.vue'

library.add(faAngleDown)

@Component({
	components: {
		Loader,
		BadgeAprovado,
		BadgeNaoAprovado,
		BadgePendente,
	},
})
export default class DropdownStatus extends Vue {
	@Prop({ required: true }) readonly status
	@Prop() readonly saving
	@Prop() readonly reportType
	@Prop() readonly attachments

	statusComponents = emailsHelper.statusComponents()

	onStatusChange(status) {
		this.$emit('status-change', status)
	}
}
